export default [
  {
    path: '/analytics/',
    name: 'analytics',
    component: () => import('../views/analytics/index.vue')
  },
]
